import { render } from "./retour_produit_create.vue?vue&type=template&id=1934faba"
import script from "./retour_produit_create.vue?vue&type=script&lang=js"
export * from "./retour_produit_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__